export function start(detail) {
    // console.log('menu start >', detail)
    switch (detail.act) {
        case 'renderNavMenu':
            renderNavMenu(detail);
            break;
        case 'hide':
            hide(detail);
            break;
    }
}

export function renderNavMenu(detail) {
    const { container, target: detailTarget, items = [] } = detail;

    const target = typeof container === 'string'
        ? document.querySelector(container)
        : (container || detailTarget);

    if (!target || !items.length) return;

    const navmenuHtml = document.createElement('div');
    navmenuHtml.className = 'navmenu';

    items.forEach(item => {
        const itemCont = document.createElement('div');
        const isSelectedClass = (item.selected || item.active) ? ' navmenu__cont--selected' : '';
        const hasSubmenu = Array.isArray(item.submenu) && item.submenu.length > 0;

        itemCont.className = `navmenu__cont navmenu__cont--normal${isSelectedClass}${hasSubmenu ? ' navmenu__cont--has-submenu' : ''}`;

        if (hasSubmenu) {
            // Renderizado de opción padre con flecha desplegable
            itemCont.innerHTML = `
                <a>
                    <svg>
                        <use xlink:href="./css/svg.svg#${item.icon || 'print'}"></use>
                    </svg>
                    <span>${item.label}</span>
                    <svg class="navmenu__arrow">
                        <use xlink:href="./css/svg.svg#downs"></use>
                    </svg>
                </a>
                <div class="navmenu__submenu"></div>
            `;

            const submenuCont = itemCont.querySelector('.navmenu__submenu');

            // Renderizamos cada opción dentro del submenú
            item.submenu.forEach(subItem => {
                const subDetailPayload = subItem.dataDetail
                    ? JSON.stringify(subItem.dataDetail)
                    : JSON.stringify({
                        click: [
                            { dest: "ripple" },
                            {
                                dest: subItem.dest || "reportHub",
                                elem: subItem.elem || "fullcont",
                                act: subItem.action,
                                ...subItem.extraData
                            }
                        ]
                    });

                const subOption = document.createElement('div');
                subOption.className = 'navmenu__submenu-item';
                subOption.setAttribute('data-detail', subDetailPayload);

                subOption.innerHTML = `
                    <svg>
                        <use xlink:href="./css/svg.svg#${subItem.icon || 'report'}"></use>
                    </svg>
                    <span>${subItem.label}</span>
                `;

                submenuCont.appendChild(subOption);
            });

        } else {
            // Renderizado de opción normal sin submenú
            const detailPayload = item.dataDetail
                ? JSON.stringify(item.dataDetail)
                : JSON.stringify({
                    click: [
                        { dest: "ripple" },
                        {
                            dest: item.dest || "reportHub",
                            elem: item.elem || "fullcont",
                            act: item.action,
                            ...item.extraData
                        }
                    ]
                });

            itemCont.setAttribute('data-detail', detailPayload);

            itemCont.innerHTML = `
                <a>
                    <svg>
                        <use xlink:href="./css/svg.svg#${item.icon || 'print'}"></use>
                    </svg>
                    <span>${item.label}</span>
                </a>
            `;

            itemCont.addEventListener('click', function () {
                navmenuHtml.querySelectorAll('.navmenu__cont').forEach(el => {
                    el.classList.remove('navmenu__cont--selected');
                });
                this.classList.add('navmenu__cont--selected');
            });
        }

        navmenuHtml.appendChild(itemCont);
    });

    target.innerHTML = '';
    target.appendChild(navmenuHtml);
}

export function hide(detail) {
    const { container, target: detailTarget } = detail || {};
    const target = typeof container === 'string'
        ? document.querySelector(container)
        : (container || detailTarget);

    if (target) {
        target.innerHTML = '';
    }
}